export default {
	oidc: {
	  issuer: document.URL.indexOf("localhost") > 0 || document.URL.indexOf("test") > 0 ? 'https://osk.oktapreview.com/oauth2/default' : 'https://osk.okta.com/oauth2/default',
	  clientId: document.URL.indexOf("localhost") > 0 || document.URL.indexOf("test") > 0 ? '0oabz32fcyLIjrgsG1d7' : '0oaicjn2jlOhbP9L41d7', //--'0oalemfx6sK6XQHFR1d7',
	  redirectUri: `${window.location.origin}/login/callback`,
	  scopes: ['openid', 'profile', 'offline_access', 'email'],
	  pkce: true
	}
};